import React from 'react';
export const Hero = () => {
  return <div className="relative min-h-screen flex items-center justify-center text-gray-800 overflow-hidden" data-id="element-352">
      {/* Background Video Container */}
      <div className="absolute inset-0 z-0 overflow-hidden bg-black" data-id="element-353">
        {/* YouTube iframe with parameters for background-like behavior */}
        <div className="relative w-full h-full pt-0" data-id="element-354">
          <iframe className="absolute inset-0 w-full h-full object-cover" src="https://www.youtube.com/embed/LzVG4xrUa8o?start=8&autoplay=1&mute=1&controls=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&loop=1&playlist=LzVG4xrUa8o&disablekb=1" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title="Los Cabos Luxury Resort" style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          minWidth: '100%',
          minHeight: '100%',
          width: 'auto',
          height: 'auto',
          transform: 'translate(-50%, -50%)',
          objectFit: 'cover'
        }} data-id="element-355"></iframe>
        </div>
        {/* Overlay to ensure text readability - reduced opacity */}
        <div className="absolute inset-0 bg-limestone-800 bg-opacity-55 backdrop-filter backdrop-blur-sm" data-id="element-356"></div>
      </div>
      <div className="container mx-auto px-4 sm:px-6 relative z-10 text-center" data-id="element-357">
        <h1 className="text-4xl sm:text-5xl md:text-7xl font-serif font-bold mb-4 leading-tight text-white tracking-wide" data-id="element-358">
          <span className="text-limestone-100" data-id="element-359">Elite Planners</span> Association
        </h1>
        <h2 className="text-lg sm:text-xl md:text-2xl mb-6 sm:mb-8 max-w-3xl mx-auto text-limestone-100 font-light tracking-wide" data-id="element-360">
          The exclusive network for top South Asian wedding planners in North
          America and Latin America
        </h2>
        <p className="text-lg sm:text-xl md:text-2xl mb-8 sm:mb-10 font-light italic text-limestone-100" data-id="element-361">
          "Better Together"
        </p>
        <a href="#masterclass-curriculum" className="inline-block bg-limestone-700 hover:bg-limestone-800 text-white font-bold py-3 px-8 rounded-lg text-lg transition transform hover:scale-105 shadow-xl font-serif tracking-wide" data-id="element-362">
          Join Our Masterclasses
        </a>
        <p className="mt-4 text-sm text-limestone-100 font-light" data-id="element-363">
          Limited spots available. Invitation only.
        </p>
      </div>
      <div className="absolute bottom-10 left-0 right-0 flex justify-center" data-id="element-364">
        <a href="#why-join" className="animate-bounce" data-id="element-365">
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-366">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-367"></path>
          </svg>
        </a>
      </div>
    </div>;
};